import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import { AskMeAgain } from './askMeAgain/AskMeAgain'
import { MFAActivateFactor } from './activateFactor/MFAActivateFactor'
import { MFAConfirmationCode } from './confirmationCode/ConfirmationCode'
import { StepVerification } from './twoStepVerification/TwoStepVerification'
import { MFADomain } from '../domain/mfa.services'
import { MFAService } from '../api/MFAFlowAPI'
import { LOGIN, MFA_EMROLLMENT, MFA_ENROLL_STATUS, MFA_LOGIN_SEND_CODE, MFA_OKTA_LIMIT_REQUEST, MFA_RESET_FACTOR, MFA_SETUP_EMAIL } from '../../constants'
import { EventModel } from '../../models/EventModel'
import { VerifyChallengeCode } from './VerifyChallengeCode/VerifyChallengeCode'
import ChooseFactor from './chooseFactor/ChooseFactor'
import NormalizeInput from '../shared/phoneNumberSection/PhoneNumberUtility'
import ErrorMessagePage from '../shared/errorMessagePage/ErrorMessagePage'
import { useOktaAuth } from '@okta/okta-react' 
import { MFA, MFASteps } from './MFASteps'
import MFAEmailEnrollment from './stepEmailVerification/StepEmailVerification'
import MFASmsEnrollment from './mfaEnrollment/MFAEnrollment'
import { trackEventMessage, trackEventMessageFailure } from '../../TelemetryService'
import axios from 'axios'
import { removeAskMeLaterLocalStorageItem, setMfaRememberMeDataOnLocalStorage } from '../../utils/localStorageUtils'

export const MfaWizard = ( { returnUrl, debounce, mfaAskMeAgainTimeOut, userId, user, mfaStep, phoneNumber , setPhoneNumber, factors, onErrorRetry, errorLoginRequest, 
  updateFactor, config, fromEditProfile, fromEditProfileAfterEdition, closeMFAEmbeddedWizzard, updateFactorsList } ) => {

  const [ step, setStep ] = useState( mfaStep )
  const [ factorId, setFactorId ] = useState( '' )
  const [ loading, setLoading ] = useState( false )
  const [ factor, setFactor ] = useState( MFA.FACTORS.SMS )
  
  const [ retryBodyRequest, setRetryBodyRequest ] = useState( errorLoginRequest )
  const  { oktaAuth  }  = useOktaAuth()

  const updateEnrolledFactorsList = async( enrolledFactor ) => {
    const userIdValue = MFADomain.getOktaEncryptedUserId()

    const userFactors = await MFAService.GetUserFactors( userIdValue )
    
    updateFactorsList( userFactors )

    if( enrolledFactor )
      updateFactor( enrolledFactor )
  }
  
useEffect( async () => {
  if( fromEditProfileAfterEdition ){
      setFactor( MFA.FACTORS.EMAIL )
  }
}, [ fromEditProfileAfterEdition ] )

  const getOktaEncryptedUserId = () => {
    return userId && userId != 'null' ? userId : MFADomain.getOktaEncryptedUserId()
  }

  const getPhoneNumberFromFactors = ( ) => {    
    const smsFactor = factors.find( f => f.factorType == MFA.factorType.sms && f.status == MFA_ENROLL_STATUS.ACTIVE )
    if( !smsFactor )
      return null
    let value = smsFactor?.profile?.phoneNumber
    value = value.replace( '+1', '' )
    return value
  }

   const handleCatchError = ( error, fn, params, nextStep, isResendCode ) => {     
    if( error.message.includes( '429' ) ) {
      if ( !isResendCode ){
        setStep( nextStep )
      }
    } else {
      setRetryBodyRequest( { fn, params, isLogin: false } )
      setStep( MFASteps.ErrorMessagePage )
    } 
   }
   
   const resetFactor = async(  ) => {  
    try{
      MFAService.ResetFactor( getOktaEncryptedUserId(), factorId )
      
      trackEventMessage( new EventModel( MFA_RESET_FACTOR.RESET_SUCCESS, user.webId ) )
    }
    catch( error ){
      trackEventMessageFailure( new EventModel( MFA_RESET_FACTOR.RESET_FAILURE,  user.webId ), error )
    }
  }

  const onSendCode = async ( isResendCode, selectedFactor, isUpdate ) => { 
    try {  
     setFactor( selectedFactor )
      if( isUpdate ){
        await resetFactor() 
      } 
      
      const sendCodeResponse = await MFAService.EnrollToByFactor( getOktaEncryptedUserId(), selectedFactor, phoneNumber )  
    
    if( sendCodeResponse.invalidPhoneNumber ) {
      return false
    } else {
      if( sendCodeResponse.status === MFA_ENROLL_STATUS.ACTIVE ){

        removeAskMeLaterLocalStorageItem()
        
        if ( sendCodeResponse.formToken && sendCodeResponse.formToken.length > 0 ) {
          axios.defaults.headers.common[ config?.antiForgeryHeaderName || '__RequestVerificationToken' ] = sendCodeResponse.formToken
        }

        setStep( MFASteps.ConfirmationCode ) 

        if( fromEditProfile ) 
          updateEnrolledFactorsList( factor )
        else
          updateFactor( factor )
          
      } else {
        setFactorId( sendCodeResponse.id )
        setStep( MFASteps.ActivateFactor ) 
      }
      return true
    }         
  } catch ( error  )  {
    trackEventMessageFailure( new EventModel( MFA_SETUP_EMAIL.SEND_CODE_FAILURE,  user.webId ), error )
    handleCatchError( error, onSendCode, [ isResendCode, selectedFactor, isUpdate ], MFASteps.ActivateFactor, isResendCode )
  }    
 }

 const onIssueChallenge = async ( isResendCode, selectedFactorId, factorValue ) => {
  if( !selectedFactorId ) return false
     try {
      setFactorId( selectedFactorId )      
      setFactor( factorValue )      
      const sendCodeResponse = await MFAService.IssueChallenge( userId, selectedFactorId  )        
      if( sendCodeResponse.invalidPasscode ){
        return false
      } else {
        if( sendCodeResponse.factorResult == 'CHALLENGE' ){
          setStep( MFASteps.CodeVerify ) 
         } else {
            if( !isResendCode ) {
            setStep( MFASteps.CodeVerify ) 
           }
         }
        return true
      }      
   } catch( error ) {
      const errorTraceData = factorValue == MFA.FACTORS.EMAIL ?  MFA_LOGIN_SEND_CODE.SEND_CODE_EMAIL_FAILURE :  MFA_LOGIN_SEND_CODE.SEND_CODE_SMS_FAILURE
      trackEventMessageFailure( new EventModel( errorTraceData,  user.webId ), error )
      handleCatchError( error, onIssueChallenge, [ isResendCode, selectedFactorId ], MFASteps.CodeVerify, isResendCode )  
   }    
  }

   const activateFactor = async ( passCode, mfaRememberMe ) => {    
    try {
      
      const response = await MFAService.ActivateFactor( getOktaEncryptedUserId(), factorId, passCode, mfaRememberMe )            
      if( response.invalidPasscode ){
        return false
      } else {
        if ( response.formToken.length ) {
            axios.defaults.headers.common[ config?.antiForgeryHeaderName || '__RequestVerificationToken' ] = response.formToken
        }

        removeAskMeLaterLocalStorageItem()
        
        if( response.mfaRememberMeData ) setMfaRememberMeDataOnLocalStorage( response.mfaRememberMeData )

        if( fromEditProfile )
          updateEnrolledFactorsList( factor )
        else
          updateFactor( factor )
          
        setStep( MFASteps.ConfirmationCode ) 

        if( phoneNumber ) 
          setPhoneNumber( NormalizeInput( phoneNumber ) )
        else
          setPhoneNumber( NormalizeInput( getPhoneNumberFromFactors() ) )

        trackEventMessage( new EventModel( MFA_EMROLLMENT.DONE, user.webId ) )

        return true
      }      
    } catch ( error ) {
      trackEventMessageFailure( new EventModel( MFA_EMROLLMENT.FAILURE,  user.webId ), error )
      handleCatchError( error, activateFactor, [ passCode, mfaRememberMe ] )      
    }
  }

  const onConfirmation = async ( redirectUrl ) => {     
    try {
      if( fromEditProfile ){
        closeMFAEmbeddedWizzard()
        return
      }

      setLoading( true )
      const loginResponse = await MFAService.LogInAPI( { ...user, returnUrl, userId } )    
      if( loginResponse.IsSuccess ) {
        
          const authTransaction = await  oktaAuth.signInWithCredentials( { username:loginResponse.OktaUsername, password: user.password } )
                if ( !authTransaction.sessionToken ) {                
                    throw new Error( 'Authentication process failed' )
                }

               const token = authTransaction.sessionToken
                const tokensTransaction = await  oktaAuth.token.getWithoutPrompt( {
                responseType: 'id_token', 
                sessionToken: token
            } )
    
          oktaAuth.tokenManager.setTokens( tokensTransaction.tokens )
          const urlForRedirection =  redirectUrl ?? loginResponse.ReturnUrl
          MFADomain.RedirectToReturnUrl( urlForRedirection )
      } else {
        handleCatchError( { status: 400 }, onConfirmation, [ '' ] )
        trackEventMessageFailure( new EventModel( LOGIN.FAILURE, user.webId ) )
        setLoading( false )
      }
    } catch ( error ) {
      trackEventMessageFailure( new EventModel( LOGIN.FAILURE, user.webId ), error )
      handleCatchError( error, onConfirmation, [ '' ] )
      setLoading( false )
    }
  }

  const validateChallengeCode = async ( passCode, factorValue, mfaRememberMe ) => {  
   try {
     setLoading( true )
    //  setMfaRememberMeChecked( mfaRememberMe )
     const verifyResponse= await MFAService.ValidateChallengeCode( userId, factorId, passCode, mfaRememberMe )
     if( verifyResponse.invalidPasscode || verifyResponse.factorResult !== 'SUCCESS' ) {
      trackEventMessageFailure( new EventModel( LOGIN.FAILURE, user.webId ) )
      setLoading( false )
      return false
     } else {   
      
      if( verifyResponse.mfaRememberMeData ) setMfaRememberMeDataOnLocalStorage( verifyResponse.mfaRememberMeData )
      onConfirmation()
      return true      
    }          
   } catch ( error )  {
    handleCatchError( error, validateChallengeCode, [ passCode, mfaRememberMe ] )     
    setLoading( false )
   }   
 }

  const RedirectToLogin = () => {
    if( fromEditProfile ){
      closeMFAEmbeddedWizzard()
      return
    }
    MFADomain.RedirectToLogin( )
  } 

  const RedirectToReturnUrl = () => {
    if( fromEditProfile ){
      closeMFAEmbeddedWizzard()
      return
    }
    MFADomain.RedirectToReturnUrl( returnUrl )
  } 

  const handleChooseFactor = ( factorValue ) => {  
    setFactor( factorValue )
    switch ( factorValue ) {
      case MFA.FACTORS.SMS: 
        setStep( MFASteps.SmsEnrollment )
        break
      case MFA.FACTORS.EMAIL: 
        setStep( MFASteps.EmailEnrollment )
        break
    }     
  }

  const retrySubmitEvent = async () => {     
    setLoading( true )
    if( retryBodyRequest.isLogin  ) {
     const loginResponse = await onErrorRetry()     
      if ( loginResponse.status ) {
        setStep( loginResponse.step )
      }       
    } else {
      await retryBodyRequest.fn( ...retryBodyRequest.params )
    }
    setLoading( false )
  }  

  const handleEmailEnrollmentGoBack = () =>{
    if( fromEditProfile ){
      closeMFAEmbeddedWizzard()
      return
    }

    if( factors.some( f=>f.status==MFA_ENROLL_STATUS.ACTIVE ) )
      setStep( MFASteps.ConfirmationCode )
    else
      setStep( MFASteps.ChooseFactor ) 
  }

  const handleSMSEnrollmentGoBack = () =>{
    if( fromEditProfile ){
      closeMFAEmbeddedWizzard()
      return
    }
    setStep( factors.some( f=>f.status==MFA_ENROLL_STATUS.ACTIVE ) ? MFASteps.ConfirmationCode: MFASteps.ChooseFactor ) 
  }

  const closeActivateFactor = () =>{
    if( fromEditProfileAfterEdition )
      closeMFAEmbeddedWizzard()
    else
      RedirectToReturnUrl()
  } 

  const onBackActivateFactor = () => {
    if( fromEditProfileAfterEdition )
      closeMFAEmbeddedWizzard()
    else
      setStep( factor == MFA.FACTORS.EMAIL ? MFASteps.EmailEnrollment : MFASteps.SmsEnrollment ) 
  }

  const renderComponent = () => { 
    switch ( step ) {
      case MFASteps.AskMeAgain:
        return <AskMeAgain onAskMeAgainClick= { () => MFADomain.AskMeAgainRedirect( mfaAskMeAgainTimeOut, returnUrl ) } onGetStartedClick={ () => setStep( MFASteps.ChooseFactor )  }  webId={ user.webId  }/> 
      case MFASteps.ChooseFactor:
        return <ChooseFactor onClose={ () => RedirectToReturnUrl() } onHandleClick = { ( factorValue ) => handleChooseFactor( factorValue )  }  webId={ user.webId  }/> 
      case MFASteps.EmailEnrollment:
        return <MFAEmailEnrollment email= { user.email } onClose={ () => RedirectToReturnUrl() } onHandleClick = { ( factorValue ) => onSendCode( false, factorValue, false )  } onGoBackClick = { () => handleEmailEnrollmentGoBack() } webId={ user.webId  } /> 
      case MFASteps.SmsEnrollment:  // Enrollment
        return <MFASmsEnrollment debounce={ debounce } step={ MFA.SmsEnrollment }  onClose={ () => RedirectToReturnUrl() } onSendCode={ ( factorValue ) => onSendCode( false, factorValue, false ) } onGoBack= { () => handleSMSEnrollmentGoBack() } onChangePhoneNumber = { ( value ) =>  setPhoneNumber( value ) } webId={ user.webId  } /> 
       case MFASteps.SmsUpdate:  // Update
        return <MFASmsEnrollment  debounce={ debounce } step={ MFA.SmsUpdate }  onClose={ () => RedirectToReturnUrl() } onSendCode={ ( factorValue ) => onSendCode( false, factorValue, true ) } onGoBack= { () => handleSMSEnrollmentGoBack() } onChangePhoneNumber = { ( value ) =>  setPhoneNumber( value ) } webId={ user.webId  } /> 
     case MFASteps.ActivateFactor:  // Activate
        return <MFAActivateFactor debounce={ debounce } factor = { factor } time= { MFA_OKTA_LIMIT_REQUEST } resendCode= { ( resend, factorValue ) => onSendCode( resend, factorValue, false ) } onClose={ () => closeActivateFactor() } onGoBack= { () => onBackActivateFactor() }  factorInfo= { factor == MFA.FACTORS.EMAIL ? user.email : phoneNumber }  onVerifyCode={ ( value, mfaRememberMe ) => activateFactor( value, mfaRememberMe ) }  webId={ user.webId  }
        fromEditProfileAfterEdition={ fromEditProfileAfterEdition }/> 
      case MFASteps.IssueFactor:  // Issue
        return <StepVerification onClose={ () => RedirectToLogin() } phoneNumber= { phoneNumber }  emailAddress= { user.email } onSendCode={  ( value, factorValue ) => onIssueChallenge( false, value, factorValue )  } factors= { factors }  onSetUpClick = { ( factorValue ) => handleChooseFactor( factorValue )  } webId={ user.webId  } userId= { userId } /> 
      case MFASteps.CodeVerify:  // Verify
        return <VerifyChallengeCode debounce={ debounce } time= { MFA_OKTA_LIMIT_REQUEST } resendCode={  ( resend, factorValue ) => onIssueChallenge( resend, factorId, factorValue )  } onClose={ () => RedirectToLogin() } onGoBack= { () => setStep( MFASteps.IssueFactor ) }  phoneNumber= { phoneNumber } emailAddress= { user.email } onVerifyCode={ ( value, factorValue, mfaRememberMe ) => validateChallengeCode( value, factorValue, mfaRememberMe ) } loading={ loading } factor={ factor } webId={ user.webId } /> 
      case MFASteps.ConfirmationCode:  // Confirmation
        return <MFAConfirmationCode onClose={ ( redirectUrl ) => onConfirmation( redirectUrl ) } email= { user.email } phoneNumber= { phoneNumber } factors = { factors } onSetUpClick = { ( factorValue ) => handleChooseFactor( factorValue )  } webId={ user.webId  }/> 
      case MFASteps.ErrorMessagePage:
        return <ErrorMessagePage retrySubmitEvent = { retrySubmitEvent } loading = { loading } />
      default:
        return <></>
    }
   }

  return ( <>
      {renderComponent()} 
  </>
  )
}

MfaWizard.propTypes = {
    returnUrl: PropTypes.string,
    mfaAskMeAgainTimeOut: PropTypes.number,
    userId: PropTypes.string,
    user: PropTypes.shape( {
      webId: PropTypes.string,
      password: PropTypes.string,
      rememberMe: PropTypes.bool, 
      email: PropTypes.string
    } ),
    mfaStep: PropTypes.number,
    factors: PropTypes.array,
    setPhoneNumber:  PropTypes.func,
    phoneNumber:  PropTypes.string,
    errorLoginRequest: PropTypes.shape( { 
      fn: PropTypes.func,
      params: PropTypes.array,
      isLogin: PropTypes.bool
    } ),
    onErrorRetry: PropTypes.func,
    updateFactor: PropTypes.func,
    config: PropTypes.shape( {
        antiForgeryHeaderName: PropTypes.string
    } ),
    fromEditProfile: PropTypes.bool,
    fromEditProfileAfterEdition: PropTypes.bool,
    closeMFAEmbeddedWizzard: PropTypes.func,
    updateFactorsList: PropTypes.func,
    debounce: PropTypes.bool
}